<template>
  <div class="answer-debug-wrapper">
    <div class="answer-debug">
      <table>
        <tr>
          <th>question_id</th>
          <th>position_order</th>
          <th>group_id</th>
          <th>default_value</th>
          <th>media_id</th>
        </tr>
        <tr>
          <td v-text="debugInfo.question_id" />
          <td v-text="debugInfo.position_order" />
          <td v-text="groupId" />
          <td v-text="debugInfo.default_value" />
          <td v-text="debugInfo.media_id" />
        </tr>
        <tr v-if="debugInfo.note">
          <th colspan="5">Note</th>
        </tr>
        <tr v-if="debugInfo.note">
          <td 
            colspan="5" 
            style="text-align:left;"
            v-html="debugInfo.note" />
        </tr>
      </table>
    </div>
  </div>
</template>
<style lang="scss" scoped>
    .answer-debug-wrapper {
        order:3;
        flex-basis:100%;
    }

    .answer-debug {
        background-color:#fff59d;
        //padding:.5em;
    }

    table {
        width:100%;
        font-size: .6em;
        border-collapse: collapse;
    }

    table, th, td {
        border: 1px solid black;
        text-align: center;
    }

    td {
        background-color: lighten(#fff59d, 10%);
    }
</style>
<script>
    export default {
        name: "AnswerDebug",
        props: {
            debugInfo: {
                type: Object,
                required: true
            },
        },
        computed: {
            groupId: function() {
                if(this.debugInfo.group_id > 0) {
                    return this.debugInfo.group_id
                }

                return 'no_group'
            }
        }
    }
</script>